import axios from 'axios';
import {config} from '../config'

var axiosInstance = axios.create({
  baseURL: process.env[config]
});

export default axiosInstance;
